<template>
  <v-card flat :height="height" :width="width">
    <v-flex layout row v-if="period == 'summary' && allStats > 0">
      <v-flex md4 class="flexImage">
        <v-img
          v-if="path.pictures && path.pictures[0] && path.pictures[0].url"
          :src="path.pictures[0].url"
          :height="height"
        >
        </v-img>
      </v-flex>
      <v-flex md8 pa-4>
        <v-flex layout row align-center pt-2>
          <span v-if="weekStats.totalUsers > 0" class="numberClass">
            {{ weekStats.totalUsers }}
          </span>
          <span v-else class="numberClass"> - </span>
          <span>
            {{ $t('statsPathCard.weekPlayers') }}
          </span>
        </v-flex>
        <v-flex layout row align-center pt-2>
          <span v-if="monthStats.totalUsers > 0" class="numberClass">
            {{ monthStats.totalUsers }}
          </span>
          <span v-else class="numberClass"> - </span>
          <span>
            {{ $t('statsPathCard.monthPlayers') }}
          </span>
        </v-flex>
        <v-flex layout row align-center pt-2>
          <span v-if="allStats > 0" class="numberClass">
            {{ allStats }}
          </span>
          <span v-else class="numberClass"> - </span>
          <span>
            {{ $t('statsPathCard.allPlayers') }}
          </span>
        </v-flex>
      </v-flex>
    </v-flex>
    <v-flex layout column v-if="isGraphDatas">
      <v-flex layout align-center justify-center pt-2 pb-3>
        <span v-if="period === 'week'">
          {{ $t('statsPathCard.entryWeek') }}
        </span>
        <span v-if="period === 'month'">{{
          $t('statsPathCard.entryMonth')
        }}</span>
        <span v-if="period === 'missionSummary'">
          {{ $t('statsPathCard.entryMissions') }}</span
        >
      </v-flex>
      <stats-charts
        :height="period === 'missionSummary' ? 200 : 150"
        :graphType="period"
        :gameProperties="properties"
      >
      </stats-charts>
    </v-flex>
    <v-card
      v-if="!isGraphDatas && period !== 'summary'"
      class="banner"
      color="rgba(230,230,230,0.3)"
    >
      <p v-if="period === 'missionSummary'" style="margin-top: 16px">
        {{ $t('statsPathCard.noStatsMissions') }}
      </p>
      <p v-else style="margin-top: 16px">
        {{ $t('statsPathCard.noStatsPeriod') }}
      </p>
    </v-card>
    <v-card
      v-if="period === 'summary' && allStats < 1"
      class="banner"
      color="rgba(230,230,230,0.3)"
    >
      <p style="margin-top: 16px">{{ $t('statsPathCard.noEntries') }}</p>
    </v-card>
  </v-card>
</template>

<script>
import StatsCharts from './StatsCharts';

export default {
  components: { StatsCharts },
  props: {
    pathId: {
      type: String,
      required: false,
      default: null,
    },
    path: {
      required: false,
      default: null,
    },
    statsPath: {
      required: false,
      default: null,
    },
    statsPathMissions: {
      required: false,
      default: null,
    },
    period: {
      type: String,
      default: 'week',
    },
    height: {
      type: Number,
      default: 200,
    },
    width: {
      type: Number,
      default: 400,
    },
  },
  data() {
    return {};
  },
  computed: {
    properties() {
      let obj = {};
      obj[this.period] = {
        data: this.graphDatas,
        labels: this.graphLabels,
      };
      return obj;
    },
    graphDatas() {
      if (this.period === 'week') {
        let en = this.weekStats.en;
        let fr = this.weekStats.fr;
        return { en, fr };
      } else if (this.period === 'month') {
        let en = this.monthStats.en;
        let fr = this.monthStats.fr;
        return { en, fr };
      }
      let entries = this.missionsStats.entriesValues;
      let wins = this.missionsStats.winValues;
      return { entries, wins };
    },
    isGraphDatas() {
      let isGraphDatas = false;
      const isZero = (value) => value === 0;
      Object.values(this.graphDatas).forEach((element) => {
        if (!element.every(isZero)) {
          isGraphDatas = true;
        }
      });
      return isGraphDatas;
    },
    graphLabels() {
      if (this.period === 'week') {
        let listDates = this.listDates.week;
        return listDates;
      } else if (this.period === 'month') {
        let listDates = this.listDates.month;
        return listDates;
      }
      let listeNames = this.missionsStats.labels;
      return listeNames;
    },
    listDates() {
      let week = [...Array(7).keys()].map((i) => this.dateDayBefore(i));
      let month = [...Array(30).keys()].map((i) => this.dateDayBefore(i));
      return { week, month };
    },
    weekStats() {
      let en = new Array(7).fill(0);
      let fr = new Array(7).fill(0);
      let totalUsers = 0;
      if (this.statsPath && this.statsPath.nbUsers) {
        this.statsPath.nbUsers.forEach((element) => {
          if (this.listDates.week.includes(element.date)) {
            if (element.lang === 'fr') {
              fr[this.listDates.week.indexOf(element.date)] = element.value;
            } else if (element.lang === 'en') {
              en[this.listDates.week.indexOf(element.date)] = element.value;
            }
            totalUsers += element.value;
          }
        });
      }
      return { en, fr, totalUsers };
    },
    // redondant
    monthStats() {
      let en = new Array(30).fill(0);
      let fr = new Array(30).fill(0);
      let totalUsers = 0;
      if (this.statsPath && this.statsPath.nbUsers) {
        this.statsPath.nbUsers.forEach((element) => {
          if (this.listDates.month.includes(element.date)) {
            if (element.lang === 'fr') {
              fr[this.listDates.month.indexOf(element.date)] = element.value;
            } else if (element.lang === 'en') {
              en[this.listDates.month.indexOf(element.date)] = element.value;
            }
            totalUsers += element.value;
          }
        });
      }
      return { en, fr, totalUsers };
    },
    allStats() {
      let totalUsers = 0;
      if (this.statsPath && this.statsPath.nbUsers) {
        this.statsPath.nbUsers.forEach((element) => {
          totalUsers += element.value;
        });
      }
      return totalUsers;
    },

    missionsStats() {
      let labels = [];
      let entriesValues = [];
      let winValues = [];
      if (this.statsPath && this.statsPathMissions) {
        this.statsPathMissions.forEach((mission) => {
          labels.push(this.findMissionNameById(mission.missionId));
          entriesValues.push(mission.nbStarts);
          winValues.push(mission.nbWins);
        });
      }
      return { labels, entriesValues, winValues };
    },
  },
  methods: {
    changePathTab(newTab) {
      this.pathTab = newTab;
      return this.pathTab;
    },
    dateDayBefore(nbDays) {
      const todayDate = new Date().getTime();
      const dateBefore = new Date(todayDate - nbDays * 24 * 60 * 60 * 1000)
        .toISOString()
        .substr(0, 10);
      return dateBefore;
    },
    findMissionNameById(missionId) {
      console.log('find mission', missionId);
      return this.$store.getters['missions/getMissionById'](missionId).name.fr;
    },
  },
};
</script>

<style lang="sass" scoped>
.banner
  position: absolute
  top : 50%
  left: 50%
  transform: translate(-50%, -50%);
  width: 100%;
  color: rgba(0,0,0,0.2)
  text-align: center
.flexImage
  padding: 0 0 0 !important
.v-chip--active:after, .v-chip--selected:after, .v-chip:focus:not(.v-chip--disabled):after
  background: grey
.actionCard
  margin: 0 0 0 !important
  position: absolute
  bottom: 0
.v-tabs__div
  text-transform: none !important
.greyImage
  filter: grayscale(100%)
  -webkit-filter: grayscale(100%)
  -moz-filter: grayscale(100%)
.numberClass
  width: 35px
  font-size: medium
  text-align: center
  text-justify: center
</style>
